var Shopify = Shopify || {};
// ---------------------------------------------------------------------------	
// Money format handler	
// ---------------------------------------------------------------------------	
Shopify.money_format = '$';
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
        callback();
    } else {
        setTimeout(function () {
            waitForEl(selector, callback);
        }, 100);
    }
};

function copyLinkFunction() {
    var copyText = document.getElementById("copyLinkInput");
    copyText.select();
    document.execCommand("copy");
    alert("Link Copied: " + copyText.value);
}
var $ = jQuery;

$(document).ready(function () {
    if ($('.yotpo-product-reviews').length > 0) {
        waitForEl(".yotpo-product-reviews .yotpo-stars .yotpo-icon", function () {
            $('.yotpo-product-reviews').each(function () {
                if ($(this).find('.yotpo-stars').find('.yotpo-icon.yotpo-icon-empty-star').length != 5) {
                    $(this).removeAttr('style');
                    $('.yotpo-product-reviews-tab').removeAttr('style');
                }
            });
        });
    }

    if ($(window).width() > 991) {
        $('.header .header__top-right .header__actions .header__profile').hover(
            function () {
                if ($(this).find('.wt-customer-links').length > 0) {
                    $(this).find('ul').fadeIn();
                }
            },
            function () {
                if ($(this).find('.wt-customer-links').length > 0) {
                    $(this).find('ul').fadeOut();
                }
            }
        );
    } else {
        $(document).on('click', '.header .header__top-right .header__actions .header__profile > a', function (e) {
            if ($('.header .header__top-right .header__actions .header__profile').find('.wt-customer-links').length > 0) {
                e.preventDefault();
                if ($(this).parents('.header__profile').find('ul').hasClass('wt-fade-in')) {
                    $(this).parents('.header__profile').find('ul').removeClass('wt-fade-in');
                } else {
                    $(this).parents('.header__profile').find('ul').addClass('wt-fade-in');
                }
            }
        });
    }

    if ($('.collection-about-content__desc').length > 0) {
        if ($(window).width() > 767) {
            new Cuttr('.collection-about-content__desc', {
                //options here
                truncate: 'words',
                length: 80,
                readMore: true
            });
        } else {
            new Cuttr('.collection-about-content__desc', {
                //options here
                truncate: 'words',
                length: 40,
                readMore: true
            });
        }
    }

    if ($('.vital-overlay__content ul').length > 0) {
        $('.vital-overlay__content ul').addClass('vital-overlay__list');
        $('.vital-overlay__content ul li').each(function () {
            $(this).contents().wrap('<span></span>');
        });
    }

    if ($("#js-announcement-bar-slider").length > 0) {
        let autoplaySpeed = parseInt($("#js-announcement-bar-slider").attr("data-slidetime")) * 1000;
        if ($(".announcement__inner_wrapper").length > 1) {
            $('#js-announcement-bar-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: autoplaySpeed
            });

            $(document).on('click',"#js-announcement-bar-slider .slick-arrow,#js-announcement-bar-slider .slick-dots",function(e){
                console.log(140);
                $('#js-announcement-bar-slider').slick('slickPause');
            });
        }
    }

    if ($('#js-hero-slider').length > 0) {
        let speed = 300;
        let doAutoSlide = false;
        if (typeof $("#js-hero-slider").attr('data-autoslide') !== 'undefined') {
            speed = $("#js-hero-slider").attr('data-autoslide');
            doAutoSlide = true;
        }
        $('#js-hero-slider').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            autoplay: doAutoSlide,
            autoplaySpeed: speed,
            responsive: [{
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    dots: true
                }
            }]
        });

        $(document).on('click',"#js-hero-slider .slick-arrow,#js-hero-slider .slick-dots",function(e){
            $('#js-hero-slider').slick('slickPause');
            console.log(173);
        });
    }

    //------- Initialising Slick Slider
    if ($('#js-slider-by-category').length > 0) {
        $('#js-slider-by-category').slick({
            arrows: true,
            infinite: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            slidesToShow: 5,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    infinite: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    arrows: false,
                    slidesToShow: 1.5,
                    centerMode: false,
                    infinite: true,
                }
            }
            ]
        });
    }

    if ($('.collection--by-category .collection__filter-option li').length > 0) {
        $('.collection--by-category .collection__filter-option li').on('click', function (e) {
            var filterClass = $(this).data('value');
            $('.collection--by-category .collection__filter-option li').removeClass('active');
            $(this).addClass('active');
            if (filterClass == '') {
                $('#js-slider-by-category').slick('slickUnfilter');
            } else {
                $('#js-slider-by-category').slick('slickUnfilter');
                $('#js-slider-by-category').slick('slickFilter', filterClass).slick('refresh');
                $('#js-slider-by-category').slick('slickGoTo', 0);
            }
        });
    }

    //------- Initialising Slick Slider
    if ($('.js-slider-best-selling').length > 0) {
        $('.js-slider-best-selling').each(function(ix,em) {
            let id = $(em).attr('id');
            $("#" + id).slick({
                arrows: true,
                infinite: true,
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                slidesToShow: 4,
                slidesToScroll: 1,
                lazyLoad: 'progressive',
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 2,
                        infinite: true,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        arrows: false,
                        slidesToShow: 1.5,
                        infinite: true,
                        centerMode: false
                    }
                }
                ]
            });
        });

        if ($('.collection--best-selling .collection__filter-option li').length > 0) {
            $('.collection--best-selling').each(function(ix,em) {
                let id = $(em).attr('id');
                $('#'+ id + ' .collection__filter-option li').on('click', function (e) {
                    var filterClass_best = $(this).data('value');
                    $('#'+ id + ' .collection__filter-option li').removeClass('active');
                    $(this).addClass('active');
                    let slick_id = $('#' + id).find('.js-slider-best-selling').attr('id');
                    if (filterClass_best == '') {
                        $('#' + slick_id).slick('slickUnfilter');
                    } else {
                        $('#' + slick_id).slick('slickUnfilter');
                        $('#' + slick_id).slick('slickFilter', filterClass_best).slick('refresh');
                        $('#' + slick_id).slick('slickGoTo', 0);
                    }
                });
            });
        }
    }

    if ($('#js-slider-blog').length > 0) {
        $('#js-slider-blog').slick({
            arrows: true,
            infinite: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            slidesToShow: 3,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    centerMode: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    centerMode: false
                }
            }
            ]
        });
    }

    if ($('.blog__filter-option li').length > 0) {
        $('.blog__filter-option li').on('click', function (e) {
            var filterClass_blog = $(this).data('value');
            $('.blog__filter-option li').removeClass('active');
            $(this).addClass('active');
            if (filterClass_blog == '') {
                $('#js-slider-blog').slick('slickUnfilter');
            } else {
                $('#js-slider-blog').slick('slickUnfilter');
                $('#js-slider-blog').slick('slickFilter', filterClass_blog).slick('refresh');
                $('#js-slider-blog').slick('slickGoTo', 0);
            }
        });
    }

    /* mobile menu toggle */
    if ($('.header__hamburger-toggle').length > 0) {
        $(".header__hamburger-toggle").click(function () {
            $(this).toggleClass("active");
            $('body').toggleClass('js-menu-open');
            $('header').toggleClass('menu-is-open');
        });
    }

    /* mobile menu submenu slide toggle */
    if ($('.nav__has-child').length > 0) {
        $('.nav__has-child').on('click', function () {
            if ($('header.menu-is-open').length > 0) {
                $(this).toggleClass('child__open').children('.nav__megamenu').slideToggle();
            }
        })
    }

    /* footer menu for mobile toggle */
    if ($('.collapse').length > 0) {
        $('.collapse').on('shown.bs.collapse', function () {
            $(this).parent('.footer__collapse').addClass('active-acc');
        });
    }

    $('.feature-box--style-1 .feature-box__item').matchHeight({
        byRow: false,
    });

    if ($('.collapse').length > 0) {
        $('.collapse').on('hidden.bs.collapse', function () {
            $(this).parent('.footer__collapse').removeClass('active-acc');
        });
    }

    if ($('.feature-box--style-1 .feature-box__item').length > 0) {
        $('.feature-box--style-1 .feature-box__item').matchHeight({
            byRow: false,
        });
    }

    if ($('.product__counter').length) {
        $('.product__counter i').click(function () {
            var parentFormWrapper = $(this).parents("form.product-form");
            val = parseInt($(this).parent().find('input').val());

            if ($(this).hasClass('less')) {
                val = val - 1;
            } else if ($(this).hasClass('more')) {
                val = val + 1;
            }

            if (val < 1) {
                val = 1;
            }

            $(this).parent().find('input').val(val);
            if ($(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").length > 0) {
                var oneTimePrice = $.trim($(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").attr("data-price"));
                if (typeof oneTimePrice != "undefined" && oneTimePrice != null && oneTimePrice != "") {
                    oneTimePrice = oneTimePrice * val;
                    var oneTimePriceHtml = Shopify.formatMoney(oneTimePrice, theme.settings.moneyFormat);

                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").html("");
                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").html(oneTimePriceHtml);
                }
                var subscriptionPrice = "";
                $(parentFormWrapper).find(".product__purchase-selling-plan optgroup").each(function () {
                    $(this).find("option").each(function () {
                        if ($(this).prop("selected") == true) {
                            subscriptionPrice = $(this).attr("data-price");
                        }
                    });

                });
                console.log(subscriptionPrice);
                if (typeof subscriptionPrice != "undefined" && subscriptionPrice != null && subscriptionPrice != "") {
                    subscriptionPrice = subscriptionPrice * val;
                    var subscriptionPriceHtml = Shopify.formatMoney(subscriptionPrice, theme.settings.moneyFormat);

                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #subscribe_purchase").next("label").find(".product__purchase-price").html("");
                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #subscribe_purchase").next("label").find(".product__purchase-price").html(subscriptionPriceHtml);
                }
            } else {
                if ($(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").length > 0) {
                    var simpleProductPrice = $.trim($(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").attr("data-price"));
                    simpleProductPrice = simpleProductPrice * val;

                    var simpleProductPriceHtml = Shopify.formatMoney(simpleProductPrice, theme.settings.moneyFormat);

                    $(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").html("");
                    $(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").html(simpleProductPriceHtml);
                }
            }
        });
    }

    if ($('#js-tab-load-more').length) {
        $('#js-tab-load-more').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);
            var expandHeight = $this.prev().find(".tab-pane").height();

            if ($this.prev().hasClass("expanded")) {
                $this.prev().removeClass("expanded");
                $this.removeClass("up__arrow");
                $this.prev().attr("style", "");
                $this.children('span').text("Load more");
            } else {
                $this.prev().addClass("expanded");
                $this.addClass("up__arrow");
                $this.prev().css("max-height", expandHeight + 30);
                $this.children('span').text("Load less");
            }
        })
    }

    if ($('.product__slider-main').length) {

        // On swipe event
        $('.product__slider-main').on('init', function (event, slick, direction) {
            if ($("form.product-form select[name='id']").length > 0) {
                setTimeout(function () {
                    $("form.product-form select[name='id']").trigger('change');
                }, 500);
            }
        });

        $('.product__slider-main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.product__slider-thumb',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                    dots: true,
                }
            }]
        });

        $('.product__slider-thumb').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.product__slider-main',
            dots: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
        });
    }

    if ($('.product__slider-main .product__item').length) {
        if ($(window).width() < 768) {
            $(".product__slider-main .product__item").trigger('zoom.destroy');
        } else {
            $(".product__slider-main .product__item").zoom();
        }
    }

    if ($('.sidebar').length) {
        $('.sidebar').stickySidebar({
            topSpacing: 80,
            bottomSpacing: 10,
            containerSelector: '.product',
            innerWrapperSelector: '.product__slider-inner',
            resizeSensor: true,
            minWidth: 991
        });
    }

    waitForEl(".rc_popup__hover .rc_popup__block", function () {
        if ($(".rc_popup__hover .rc_popup__block").length > 0) {
            console.log('line 523');
            var rcPopupHtml = $(".rc_popup__hover .rc_popup__block").html();
            if (typeof rcPopupHtml != "undefined" && rcPopupHtml != null && rcPopupHtml != "") {
                $(".custom_rc_popup__block").html("");
                $(".custom_rc_popup__block").html(rcPopupHtml);
            }
        }
    });
    $('.product__purchase input[name="purchase_option"]').on('change', function () {
        let purchase_type = $(this).val();
        console.log('purchase_type', purchase_type);
        if (purchase_type == "subscribe") {
            $(this).parents('.product__purchase-wrapper').find('.product__purchase-selling-plan').slideDown();
        } else {
            $(this).parents('.product__purchase-wrapper').find('.product__purchase-selling-plan').slideUp();
        }
    });
    $('.product__variant-wrapper .product__variant input[type="radio"]').on('change', function () {
        var selectedText = "";
        $(this).parents(".product__variant-outer-wrapper").find(".single-product-variant-option").each(function () {
            $(this).find(".product__variant-wrapper .product__variant").each(function () {
                if ($(this).find("input[type='radio']:checked").length > 0) {
                    var currentValue = $.trim($(this).find("input[type='radio']").val());
                    if (selectedText != null && selectedText != "") {
                        selectedText = selectedText + " / " + currentValue;
                    } else {
                        selectedText = currentValue;
                    }
                }
            });
        });
        if (typeof selectedText != "undefined" && selectedText != null && selectedText != "") {
            var parentFormWrapper = $(this).parents(".product__detail").find('form.product-form');
            if ($(parentFormWrapper).find('select[name="id"]').length > 0) {
                $(parentFormWrapper).find('select[name="id"] option').each(function () {
                    var currentText = $.trim($(this).text());
                    if (currentText == selectedText) {
                        $(parentFormWrapper).find("select[name='id'] option").removeAttr("selected");
                        $(this).attr("selected", "selected");
                        $(parentFormWrapper).find("select[name='id']").trigger("change");
                    }
                });
            }
        }
    });

    $("form.product-form select[name='id']").on("change", function (e) {
        var parentFormWrapper = $(this).parents("form.product-form");
        var dataMatch = $(this).children("option:selected").attr("data-match");
        var isVariantAvailable = $(this).children("option:selected").attr("data-availability");
        var isVariantSalePrice = $(this).children("option:selected").attr("data-is-sale-price");
        var variantOldPrice = $(this).children("option:selected").attr("data-old-price");
        var variantSalePrice = $(this).children("option:selected").attr("data-sale-price");
        var variantImageName = $(this).children("option:selected").attr("data-image-name");

        if (variantImageName) {
            let image_index = $(`.product__slider-main .product__item[data-src='${variantImageName}']`).attr('data-index');
            if (typeof image_index !== 'undefined') {
                $(`.product__slider-main`).slick('slickGoTo', image_index - 1);
            }
        }

        var variantId = $(this).children("option:selected").attr("value");
        var variantSKU = $(this).children("option:selected").attr("data-sku");
        if ($(parentFormWrapper).find(".product__purchase-selling-plan").length > 0) {
            $(parentFormWrapper).find(".product__purchase-selling-plan optgroup").each(function () {
                $(this).find("option").removeAttr("selected");
                var labelAttr = $.trim($(this).attr("label"));
                if (labelAttr == dataMatch) {
                    $(parentFormWrapper).find(".product__purchase-selling-plan optgroup").css("display", "none");
                    $(this).css("display", "block");
                    $(this).find("option:first-child").attr("selected", true);
                }
            });
        }
        if (isVariantAvailable == "true") {
            $(parentFormWrapper).find(".custom-add-to-cart-btn").removeAttr("disabled", "disabled");
            $(parentFormWrapper).find(".custom-add-to-cart-btn").text("");
            $(parentFormWrapper).find(".custom-add-to-cart-btn").text("Add to cart");
        } else {
            $(parentFormWrapper).find(".custom-add-to-cart-btn").attr("disabled", "disabled");
            $(parentFormWrapper).find(".custom-add-to-cart-btn").text("");
            $(parentFormWrapper).find(".custom-add-to-cart-btn").text("Out of stock");
        }
        var priceHtml = '';
        var perPriceHtml = '';
        var quantityInputValue = $.trim($(parentFormWrapper).find('input[name="quantity"]').val());
        var variantSalePriceWithQuantity = variantSalePrice * quantityInputValue;
        if (isVariantSalePrice == "true") {
            variantOldPrice = parsetInt(variantOldPrice) * parseInt(quantityInputValue);
            priceHtml += '<del class="font-weight-normal">' + Shopify.formatMoney(variantOldPrice, theme.moneyFormat) + '</del> ' + Shopify.formatMoney(variantSalePriceWithQuantity, theme.settings.moneyFormat);
        } else {
            priceHtml += Shopify.formatMoney(variantSalePriceWithQuantity, theme.settings.moneyFormat);
        }
        if (typeof priceHtml != "undefined" && priceHtml != null && priceHtml != "") {
            if ($(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").length > 0) {
              	$(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").attr("data-price", variantSalePrice);
                $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").html("");
                $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #one_time_purchase").next("label").find(".product__purchase-price").html(priceHtml);
                var rechargePrice = "";
                var rechargePriceOriginal = "";
                $(parentFormWrapper).find(".product__purchase-selling-plan optgroup").each(function () {
                    var labelAttr = $.trim($(this).attr("label"));
                    if (labelAttr == dataMatch) {
                        $(this).find("option").each(function (index, element) {
                            if (index == 0) {
                                rechargePriceOriginal = $(this).attr("data-price");
                                rechargePrice = $(this).attr("data-price");
                                rechargePrice = rechargePrice * quantityInputValue;
                            }
                        });
                    }
                });
                if (typeof rechargePrice != "undefined" && rechargePrice != null && rechargePrice != "") {
                    var rechargePriceHtml = Shopify.formatMoney(rechargePrice, theme.settings.moneyFormat);
                  	$(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #subscribe_purchase").next("label").find(".product__purchase-price").attr("data-price", rechargePriceOriginal);
                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #subscribe_purchase").next("label").find(".product__purchase-price").html("");
                    $(parentFormWrapper).find(".product__purchase-wrapper .product__purchase #subscribe_purchase").next("label").find(".product__purchase-price").html(rechargePriceHtml);
                }
            } else {
                if ($(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").length > 0) {
                    $(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").attr("data-price", variantSalePrice);
                    $(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").html("");
                    $(parentFormWrapper).find(".product__quntity-button-wrapper .product__price p").html(priceHtml);
                }
            }
        }
        if (typeof variantSKU != "undefined" && variantSKU != null && variantSKU != "") {
            $(".section.product").find(".product__meta-list li:last-child span").html("");
            $(".section.product").find(".product__meta-list li:last-child span").html("SKU:" + variantSKU);
        }
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
        window.history.replaceState({
            path: newurl
        }, '', newurl);
    });
    $(".custom-add-to-cart-btn").on("click", function (e) {
        e.preventDefault();
        if ($("#bpn_content1").length > 0 && $("#bpn_content2").length > 0) {
            if (!$('#personalization-not-required').prop("checked")) {
                var hasAnyValue = false;
                $('#bpn_content1,#bpn_content2').find('.properties').each(function () {
                    if ($(this).val() != "undefined" && $(this).val() != "" && $(this).val() != null) {
                        hasAnyValue = true;
                        return false;
                    }
                });

                if (hasAnyValue) {
                    $('#bpn_content1,#bpn_content2').find('.properties').each(function () {
                        $(this).removeAttr("required");
                    });
                    $('.personalization-error').slideUp();
                } else {
                    $('.personalization-error').slideDown();
                }
            } else {
                $('.personalization-error').slideUp();
            }
        }
        $(this).parents("form.product-form").submit();
    });
  
    $('form.product-form').on('submit', function (e) {
        e.preventDefault();
        var variantId = "";
        var quantity = "";
        var sellingPlan = "";
        if ($(this)[0].checkValidity()) {
            if ($(this).find('input[name="id"]').length > 0) {
                variantId = $.trim($(this).find('input[name="id"]').val());
            } else if ($(this).find('select[name="id"]').length > 0) {
                variantId = $.trim($(this).find('select[name="id"]').val());
            }
            if ($(this).find('input[name="quantity"]').length > 0) {
                quantity = $.trim($(this).find('input[name="quantity"]').val());
            }
            if ($(this).find('.product__purchase-wrapper .product__purchase input[type="radio"]').length > 0) {
                var selectRadioValue = "";
                $(this).find(".product__purchase-wrapper .product__purchase").each(function () {
                    if ($(this).find('input[type="radio"]').length) {
                        if ($(this).find('input[type="radio"]').prop("checked") == true) {
                            selectRadioValue = $.trim($(this).find('input[type="radio"]').val());
                        }
                    }
                });
                if (typeof selectRadioValue != "undefined" && selectRadioValue != null && selectRadioValue != "" && selectRadioValue == "subscribe") {
                    sellingPlan = $.trim($(this).find('select[name="selling_plan"]').val());
                }
            }

            if (typeof variantId != "undefined" && variantId != null && variantId != "" &&
                typeof quantity != "undefined" && quantity != null && quantity != "") {
                var properties = {};
                if ($("#bpn_content1").length > 0 && $("#bpn_content2").length > 0) {
                    if (!$('#personalization-not-required').prop("checked")) {
                        $('#bpn_content1,#bpn_content2').find('.properties').each(function () {
                            if ($(this).val() != "undefined" && $(this).val() != "" && $(this).val() != null) {
                                var propertiesName = $.trim($(this).attr("data-name"));
                                properties[propertiesName] = $.trim($(this).val());
                            }
                        });
                    } else {
                        properties["Personalization"] = "No";
                    }
                }

                data = {
                    "id": variantId,
                    "quantity": quantity,
                    "selling_plan": sellingPlan,
                    "properties": properties
                }
                // var formSerialize = $(this).serialize();
                jQuery.ajax({
                    url: "/cart/add.js",
                    data: data,
                    method: "POST",
                    dataType: 'json',
                    success: function () {
                        window.location.href = '/cart';
                    },
                    error: function (data) {
                        alert(data.responseJSON.description);
                    }
                });
            }
        }
    });
    $(".page-product .product .product__slider-wrapper .product__slider-inner .product__actions .product__share").on("click", function () {
        var productTitle = $.trim($(this).attr("data-title"));
        var productUrl = $.trim($(this).attr("data-link"));
        if (typeof productTitle != "undefined" && productTitle != null && productTitle != "" &&
            typeof productUrl != "undefined" && productUrl != null && productUrl != "") {
            if ($(window).width() > 767) {
                if ($(".social-share-wrapper").is(":visible")) {
                    $(".social-share-wrapper").slideUp();
                } else {
                    $(".social-share-wrapper").slideDown();
                }
            } else {
                if (navigator.share) {
                    navigator.share({
                        title: productTitle,
                        url: productUrl
                    }).then(() => {
                        console.log('Thanks for sharing!');
                    })
                        .catch(console.error);
                } else {
                    // fallback
                }
            }
        }

    });

    /* SHOP-201 starts */
    $(window).scroll(function () {
        var height = $(window).scrollTop();
        if (height > 300) {
            $('#back2Top').fadeIn();
        } else {
            $('#back2Top').fadeOut();
        }
    });

    $(document).ready(function () {
        $("#back2Top").click(function (event) {
            event.preventDefault();
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            return false;
        });
        if ($(".mobile-nav__faux-link").eq(0).parents("button").eq(0).attr('aria-expanded') == 'false') {
            $(".mobile-nav__faux-link").eq(0).trigger("click");
        }
    });
    /* SHOP-201 ends */

    $('form.product-form').on('submit', function (e) {
        e.preventDefault();
        let current_em = $('button.custom-add-to-cart-btn');
        let formData = new FormData($('form.product-form')[0]);
        let purchase_option = $('[name="purchase_option"]:checked').val();
        if(purchase_option == 'one_time') {
            formData.delete('selling_plan');
        }
        $.ajax({
            type: "POST",
            enctype: 'multipart/form-data',
            url: "/cart/add.js",
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function (data) {
                $(current_em).text('Added');
                $.getJSON("/cart.json", function (data) {
                    $(".header__cart-count").text(data.item_count);
                });
            },
            error: function (e) {

            }
        });
        return false;
    });

});

var selector = $(".wt-category-carousel-nosto");
var count = 0;
var selectornew = $(".snize-collection-mode");

var waitForElNew = function (selector, callback) {
    var selectornew = $(".snize-collection-mode");

    // if(!count) {
    //     count=0;
    // }
    count++;
    if (selectornew.length) {
        callback();
        // console.log("Yeah");
    } else {
        setTimeout(function () {
            waitForElNew(selectornew, callback);
        }, 1000);
    }
};

function getParams(url) {

    var queryString = url.substring(url.indexOf('?') + 1);
    var paramsArr = queryString.split('&');
    var params = [];

    for (var i = 0, len = paramsArr.length; i < len; i++) {
        var keyValuePair = paramsArr[i].split('=');
        params.push({
            name: keyValuePair[0],
            value: keyValuePair[1]
        });
    }

    return params;
}

waitForElNew(selectornew, function () {
    var getFeatureContent = $("<div />").append($("#wt-category-featured-products").clone()).html();
    var resultval = $('.snize-main-panel-collection-results-found b').text();

    $("#snize-search-results-grid-mode").prepend('<div class="collection__head"><h2 class="collection__title">All Products</h2>' + '<span>' + resultval + ' ' + 'results</span></div>');

    $("#snize-search-results-grid-mode").prepend(getFeatureContent);

    $("#snize-search-results-grid-mode").prepend('<div class="filter-option"><div class="filter-option__items"></div></div>');

    var currentUrl = window.location.href;
    var getAllParam = getParams(currentUrl);
    var collectionTitle = "";
    if ($(".has-collection-title").length > 0) {
        collectionTitle = $.trim($(".has-collection-title").attr("data-collection-title"));
    }
    
    if (getAllParam.length == 1 || getAllParam.length == 2) {
        $(getAllParam).each(function (index, element) {
            if (typeof element.name != "undefined" && element.name != null && element.name != "") {
                if (element.name != "page") {
                    if (element.name == "rb_product_type" || element.name == "rb_vendor" || element.name == "rb_tags") {
                        if (typeof element.value != "undefined" && element.value != null && element.value != "") {
                            var decodedURL = decodeURIComponent(element.value);
                            var decodedText = decodedURL.replace(/\\/g, "");
                            decodedText = decodedText.replace(/\+/g, ' ');
                            decodedText = decodedText.replace(/\-/g, ' ');
                            if (typeof decodedText != "undefined" && decodedText != null && decodedText != "") {
                                var splitText = decodedText.split("|");
                                if (splitText.length > 0) {
                                    collectionTitle = "";
                                    $(splitText).each(function (newindex, newlelement) {
                                        if (newindex == 0) {
                                            collectionTitle = newlelement;
                                        } else if (newindex == 1) {
                                            collectionTitle = collectionTitle + " | " + newlelement;
                                        }
                                    });
                                }

                            }
                        }
                    }
                }
            }
        });
    }

    $("#snize-search-results-grid-mode").prepend('<h2 class="page-title custom-collection-title">' + collectionTitle + '</h2>');

    $(".snize-filters-sidebar .snize-product-filters-checkbox:checked").each(function () {
        if ($(".snize-filters-sidebar .snize-product-filters-checkbox:checked").val()) {
            var filterOption = $(this).attr('value');
            $(".filter-option__items").append('<span class="filter-option__item">' + filterOption + `<img src="//cdn.shopify.com/s/files/1/0078/5589/8676/t/98/assets/close.svg?v=111472192449408444811626097269" class="filter-option__close" alt="">` + '</span>');
        }
    });

    $(document).on('change', ".snize-filters-sidebar .snize-product-filters-checkbox", function () {
        var filteroptionNew = $(this).attr('value');
      	console.log('changed',this.checked);
        if(this.checked) {
            $(".filter-option__items").append('<span class="filter-option__item">' + filteroptionNew + `<img src="//cdn.shopify.com/s/files/1/0078/5589/8676/t/98/assets/close.svg?v=111472192449408444811626097269" class="filter-option__close" alt="">` + '</span>');
        } else {
            $('.filter-option__item').each(function(ix,em) {
                if($(em).text() == filteroptionNew) {
                    $(em).remove();
                }
            });
        }

        if ($('.filter-option__item').length > 0) {
            if($(".filter-option .filter-option__clear-all").length == 0) {
                $(".filter-option").append('<span class="filter-option__clear-all">Clear all</span>');
            }
        } else {
            $(".filter-option .filter-option__clear-all").remove();
        }
    });
    
    if ($('.filter-option__item').length > 0 && $(".filter-option .filter-option__clear-all").length == 0) {
        $(".filter-option").append('<span class="filter-option__clear-all">Clear all</span>');
    }

    $(document).on('click', '.filter-option__close', function () {
        var filterRemoveoption = $(this).parent('.filter-option__item').text();
        $('.snize-filter-checked').each(function(ix,em) {
            let filterValue = $(em).find('.snize-product-filters-checkbox').val();
            if(filterRemoveoption == filterValue) {
                $(em).find('.snize-product-filters-checkbox').prop('checked', false).trigger('change');
                $(em).find('.snize-product-filters-checkbox').attr('checked', false).trigger('change');
                $(em).find('.needsclick').trigger('click');
                return false;
            }
        });

        $('.filter-option__item').each(function(ix,em) {
            if($(em).text() == filterRemoveoption) {
                $(em).remove();
            }
        });
      
      	if ($('.filter-option__item').length > 0) {
            
        } else {
            $(".filter-option .filter-option__clear-all").remove();
        }
    });
  
    $(document).on('click', '.filter-option__clear-all', function () {
      var collectionHandle = $('#PageContainer').attr('data-handle');
      window.location = collectionHandle;
    });

    $('#wt-category-recently-viewed .wt-category-carousel-nosto').slick({
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    infinite: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1.5,
                    infinite: false,
                    centerMode: false,
                }
            }
        ]
    });

    $('#wt-category-featured-products .wt-category-carousel-nosto').slick({
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    infinite: true,
                    centerMode: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1.5,
                    infinite: false,
                    centerMode: false,
                }
            }
        ]
    });
});

if ($('.filter-option__item').length) {
    $('.filter-option__close').on('click', function () {
        var filterRemoveoption = $(this).parent('.filter-option__item').text();
        console.log(filterRemoveoption);
    })
}

$('#wt-category-recently-viewed .wt-category-carousel-nosto').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 769,
        settings: {
            arrows: true,
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            arrows: true,
            slidesToShow: 1.5,
            infinite: false,
            centerMode: false,
        }
    }
    ]
});

$('#wt-category-featured-products .wt-category-carousel-nosto').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [{
        breakpoint: 769,
        settings: {
            arrows: true,
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            arrows: true,
            slidesToShow: 1.5,
            infinite: false,
            centerMode: false,
        }
    }
    ]
});



$(window).scroll(function () {
    // if ($(window).width() > 991) {
    //     if ($(window).scrollTop() > header_height) {
    //         $('.header__main-wrapper,.header__searchbar_wrapper').addClass('header__scroll-sticky').addClass('header__scroll-open');
    //     } else {
    //         $('.header__main-wrapper,.header__searchbar_wrapper').removeClass('header__scroll-sticky').removeClass('header__scroll-open');;
    //     }
    // } else {
    //     if ($(window).scrollTop() > header_height) {
    //         $('.header .header__top').addClass('header__scroll-sticky').addClass('header__scroll-open');
    //     } else {
    //         $('.header .header__top').removeClass('header__scroll-sticky').removeClass('header__scroll-open');;
    //     }
    // }
});

$(window).resize(function () {
    if ($(window).width() < 768) {
        $(".product__slider-main .product__item").trigger('zoom.destroy');
    }
});


$(document).ready(function () {
    /* desktop*/
    if ($('.pricing-plan__radio-input').length) {
        $('.pricing-plan__radio-input').on('change', function () {
            if ($('[name="pricing_plan"]:checked').val() === 'one-year') {
                $('[data-plan="true"]').html('year');

                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-yearly-plan'));
                });

            }
            else if ($('[name="pricing_plan"]:checked').val() === 'six-month') {
                $('[data-plan="true"]').html('six-month');

                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-quater-month-plan'));
                });
            }
            else {
                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-monthly-plan'));
                });
            }

        });
    }
    /* mobile */
    if ($('.m-pricing-plan__radio-input').length) {
        $('.m-pricing-plan__radio-input').on('change', function () {
            if ($('[name="m_pricing_plan"]:checked').val() === 'm-one-year') {
                $('[data-plan="true"]').html('year');

                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-yearly-plan'));
                });

            }
            else if ($('[name="m_pricing_plan"]:checked').val() === 'm-six-month') {
                $('[data-plan="true"]').html('six-month');

                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-quater-month-plan'));
                });
            }
            else {
                $('[data-plan="true"]').each(function () {
                    $(this).html($(this).attr('data-monthly-plan'));
                });
            }

        });
    }

    if ($('#pricing_plan_slider').length) {
        $('#pricing_plan_slider').slick({
            arrows: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 1.5,
                        infinite: false,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 479,
                    settings: {
                        arrows: false,
                        slidesToShow: 1.1,
                        infinite: false,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 374,
                    settings: {
                        arrows: false,
                        slidesToShow: 1.05,
                        infinite: false,
                        centerMode: false,
                    }
                }
            ]
        });
    }

    // Add smooth scrolling to all links
    $("a.smooth-scrolling").on('click', function (event) {
        var hash = this.hash;

        if (this.hash !== "") {
            if ($(window).width() > 991) {
                var menu_height = $('#shopify-section-header .header__main').height();
            } else {
                var menu_height = $('#shopify-section-header .header__top').height();
            }

            console.log('menu_height', menu_height);
            event.preventDefault();
            $("html, body").animate({ scrollTop: $(hash).offset().top - menu_height }, "slow");
            return false;
        }
    });
});

$(window).resize(function () {
    if ($(window).width() < 768) {
        $(".product__slider-main .product__item").trigger('zoom.destroy');
    }
});


/* sticky scroll */
$(document).ready(function() {

    var previousScroll = 0;
    var headerHeight = $('.header').height();
    $('#shopify-section-header').css('height', headerHeight);
  
    $(window).scroll(function() {
  
      var currentScroll = $(this).scrollTop();
  
      // If the current scroll position is greater than 0 (the top) AND the current scroll position is less than the document height minus the window height (the bottom) run the navigation if/else statement.
      if (currentScroll > headerHeight && currentScroll < $(document).height() - $(window).height()) {
  
        // If the current scroll is greater than the previous scroll (i.e we're scrolling down the page), hide the nav.
        if (currentScroll > previousScroll) {
          window.setTimeout(hideNav, 300);
  
          // Else we are scrolling up (i.e the previous scroll is greater than the current scroll), so show the nav.
        } else {
          window.setTimeout(showNav, 300);
        }
  
        // Set the previous scroll value equal to the current scroll.
        previousScroll = currentScroll;
      }
  
    });
  
    function hideNav() {
        $(".header").removeClass("header__scroll-sticky").removeClass('header__scroll-open').addClass("header__scroll-up");
    }
  
    function showNav() {
        $(".header").removeClass("header__scroll-up").addClass('header__scroll-sticky').addClass('header__scroll-open');
    }
  
});

$(window).resize(function () {
    var previousScroll = 0;
    var headerHeight = $('.header').height();
    $('#shopify-section-header').css('height', headerHeight);
  
    $(window).scroll(function() {
  
      var currentScroll = $(this).scrollTop();
  
      // If the current scroll position is greater than 0 (the top) AND the current scroll position is less than the document height minus the window height (the bottom) run the navigation if/else statement.
      if (currentScroll > headerHeight && currentScroll < $(document).height() - $(window).height()) {
  
        // If the current scroll is greater than the previous scroll (i.e we're scrolling down the page), hide the nav.
        if (currentScroll > previousScroll) {
          window.setTimeout(hideNav, 300);
  
          // Else we are scrolling up (i.e the previous scroll is greater than the current scroll), so show the nav.
        } else {
          window.setTimeout(showNav, 300);
        }
  
        // Set the previous scroll value equal to the current scroll.
        previousScroll = currentScroll;
      }
  
    });
  
    function hideNav() {
        $(".header").removeClass("header__scroll-sticky").removeClass('header__scroll-open').addClass("header__scroll-up");
    }
  
    function showNav() {
        $(".header").removeClass("header__scroll-up").addClass('header__scroll-sticky').addClass('header__scroll-open');
    }
});


$(document).ready(function(){
    $('.header__action-toggle > a').on('click',function(e){
        e.preventDefault();
        if($(this).next('.header__action-menu').is(':visible')) {
            $(this).next('.header__action-menu').fadeOut();
        }
        else {
            $(this).next('.header__action-menu').fadeIn();
        }
    });

    let swat_interval = window.setInterval(function(){
        if(typeof window._swat != 'undefined') {
            window._swat.renderWishlistCount($('.header__wishlist-count')[0], function(cnt, elem){
                console.log("renderWishlistCount was called", cnt, elem);
                $('.header__wishlist-count').text(cnt);
            }, 500);
            clearInterval(swat_interval);
        }
    },250);
    
});

/* Community JS starts */
$(document).ready(function(){
    if($('#js-featurebox-slider').length) {
        $('#js-featurebox-slider').slick({
            dots: false,
            slidesPerRow: 2,  
            rows: 3  
        }); 
    }

    $('#js-features-slider-top').slick({
        slidesToShow: 2.1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        asNavFor: '#js-features-slider-bottom'
    });

    $('#js-features-slider-bottom').slick({
        slidesToShow: 2.1,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '#js-features-slider-top',
        dots: false,
      });

    if ($('#js-pet-essential-slider').length > 0) {
        $('#js-pet-essential-slider').slick({
            arrows: true,
            infinite: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            slidesToShow: 3,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    infinite: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    arrows: false,
                    slidesToShow: 1.2,
                    infinite: false,
                    centerMode: false
                }
            }
            ]
        });
    }

    //------- Initialising Slick Slider
    if ($('#js-slider-best-deals').length > 0) {
        $('#js-slider-best-deals').slick({
            arrows: true,
            infinite: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            slidesToShow: 3,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    centerMode: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    arrows: false,
                    infinite: false,
                    centerMode: false,
                    slidesToShow: 1.2,
                }
            }
            ]
        });
    }

    if ($('.collection--best-deals .collection__filter-option li.active').length > 0) {
        var filterClass = $('.collection--best-deals .collection__filter-option li.active').data('value');
        $('#js-slider-best-deals').slick('slickUnfilter');
        $('#js-slider-best-deals').slick('slickFilter', filterClass).slick('refresh');
        $('#js-slider-best-deals').slick('slickGoTo', 0);
    }

    if ($('.collection--best-deals .collection__filter-option li').length > 0) {
        $('.collection--best-deals .collection__filter-option li').on('click', function (e) {
            var filterClass = $(this).data('value');
            $('.collection--best-deals .collection__filter-option li').removeClass('active');
            $(this).addClass('active');
            if (filterClass == '') {
                $('#js-slider-best-deals').slick('slickUnfilter');
            } else {
                $('#js-slider-best-deals').slick('slickUnfilter');
                $('#js-slider-best-deals').slick('slickFilter', filterClass).slick('refresh');
                $('#js-slider-best-deals').slick('slickGoTo', 0);
            }
        });
    }
});
/* Community JS ends */

$(document).ready( function() {
  $('a[href^="/account/logout"]').on("click", function() {
    $.ajax( $(this).attr('href') )
    .done(function() {
      // Here you will change the url to whatever page you want to redirect to
      window.location.href = "https://petlover.petstablished.com/shopify_logout?return_url=https://www.wagtopia.com";
    });
    return false;
  });
});

/* Home page shelter JS starts *//* Home page shelter JS starts */
$(document).ready( function() {
  var currentUrl = window.location.href;
  var getAllParam = getParams(currentUrl);
  var hasShelterParamInUrl = 0;
  if (getAllParam.length > 0 ) {
    $(getAllParam).each(function (index, element) {
    	if (typeof element.name != "undefined" && element.name != null && element.name != "" && element.name == "shelter") {
          var shelterToken = $.trim(element.value);
          if(typeof shelterToken !== "undefined" && shelterToken !== null && shelterToken !== "") {
            hasShelterParamInUrl = 1;
            $.ajax({
              url: 'https://petstablished.com/api/shelter/' + shelterToken,
              type: 'GET',
              datatype: 'json'
            })
            .done(function (data) {
              if(typeof data.logo_url !== "undefined" && data.logo_url !== null && data.logo_url !== "") {
                let shelter_logo = data.logo_url;
                let shelter_name = data.name;
                let shelter_html = `<section class="home-shelter-wrapper"><div class="custom__container container"><div class="user-shelter-details-wrappper"><section class="user-shelter-details">
                                  <div class="thankyou__media-image"><img src='${shelter_logo}'/></div>
                                  <div class="thnk__desc--head"><span>${shelter_name} </span> thanks you for your support</div>
                                </div></div></section></section>`;
                if($(".wt-shelter-top-wrapper").length > 0) {
                  if($('.wt-customer-details').length > 0) {
                    let customer_id = $('.wt-customer-details').attr('data-id');
                    shelter_html = `<div class="wt-customer-details" data-id="${customer_id}"></div>` + shelter_html;
                  }

                  $(".wt-shelter-top-wrapper").html("");
                  $(".wt-shelter-top-wrapper").html(shelter_html);
                }
            	$.cookie('custom_shelter', 'true', { expires: 7, path: '/'});
                $.post('/cart/update.js', "attributes[shelter_token]="+shelterToken);
                if($('.wt-customer-details').length > 0) {
                  let customer_id = parseInt($('.wt-customer-details').attr('data-id'));
                  var myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");

                  var raw = JSON.stringify({
                    "customer_id": customer_id,
                    "shelter_token": shelterToken
                  });

                  var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'follow'
                  };
                  
                  console.log(raw);

                  fetch("https://2mn1wg998h.execute-api.us-east-1.amazonaws.com/production/api/updateshelter", requestOptions)
                  .then(response => response.text())
                  .then(result => console.log(result))
                  .catch(error => console.log('error', error));
                }
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {

            });
          }
        }
    });
  }
  
  if(hasShelterParamInUrl) {
    
  } else {
    if($(".user-shelter-details-wrappper").length > 0) {
      var checkShelterCookie = $.cookie('custom_shelter');
      if(typeof checkShelterCookie !== "undefined" && checkShelterCookie !== null && checkShelterCookie !== "" && checkShelterCookie == "true") {

      } else {
        var shelterToken = $.trim($(".user-shelter-details-wrappper").attr("data-customer-shelter"));
        if(typeof shelterToken !== "undefined" && shelterToken !== null && shelterToken !== "") {
          $(".user-shelter-details-wrappper").html("");
          $.ajax({
            url: 'https://petstablished.com/api/shelter/'+shelterToken,
            type: 'GET',
            datatype: 'json'
          })
          .done(function (data) {
            if(typeof data.logo_url !== "undefined" && data.logo_url !== null && data.logo_url !== "") {
              let shelter_logo = data.logo_url;
              let shelter_name = data.name;
              let shelter_html = `<section class="user-shelter-details">
                                    <div class="thankyou__media-image"><img src='${shelter_logo}'/></div>
                                    <div class="thnk__desc--head"><span>${shelter_name} </span> thanks you for your support</div>
                                  </section>`;
              $(".user-shelter-details-wrappper").html(shelter_html);
              $.cookie('custom_shelter', 'true', { expires: 7, path: '/'});
              $.post('/cart/update.js', "attributes[shelter_token]="+shelterToken);
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {

          });
        }
      }

    }
  }
});
/* Home page shelter JS ends */

/* Wagstoriches JS starts */

$(document).ready( function() {
  if($('.wagstoriches-how-it-works-single-step').length > 0 && $(window).width() > 767) {
    $('.wagstoriches-how-it-works-single-step').matchHeight();
  }
  
  $(document).on('submit','.wagstoriches-contact-form', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    let awo_name = $('input[name="wtr_awo_name"]').val();
    let contact_name = $('input[name="wtr_contact_name"]').val();
    let email = $('input[name="wtr_email"]').val();
    let phone_number = $('input[name="wtr_phone_number"]').val();

    $.ajax({
      type: "POST",
      beforeSend: function(request) {
        request.setRequestHeader("X-API-Token", "590e83b55c2e5a8abae0901c8d0ff9f9");
      },
      contentType: 'application/json',
      url: "https://petstablished.com/api/add_marketing_details",
      data: JSON.stringify({awo_name: awo_name, contact_name: contact_name, email: email, phone_number: phone_number}),
      success: function( data, textStatus, jQxhr ){
        $("#wagstoriches-contact-form")[0].reset();
        let wagstoriches_modal = new theme.Modals('wagstoriches-contact-form-popup');
        wagstoriches_modal.open();
      },
      error: function( jqXhr, textStatus, errorThrown ){
        console.log( errorThrown );
        alert("There was some error submitting the form. Please check the details and try again.");
      }
    });
  });

  $(document).on('click','.header__top-search-form .input-group-append',function(e){
    let search_term = $(`[name="q"]:visible`).val().trim();
    window.location = `/pages/search-results-page?q=${search_term}`;
  });
});

/* Wagstoriches JS ends */